<template>
  <el-dialog :visible="visible" @close="onClose" title="修改价格" width="700px">
    <div class="m-b10">商品：{{ currentGoodsInfo.title }}</div>
    <template v-if="currentGoodsInfo.skuList && currentGoodsInfo.skuList.length > 0">
      <el-form label-position="left" inline>
        <el-form-item :label="item.title" v-for="item in currentGoodsInfo.skuList" :key="item.id">
          <el-input v-model="item.price" @input="inputHandler(item, 'price')">
            <template slot="suffix"> 元/{{ currentGoodsInfo.valuationUnit }} </template>
          </el-input>
        </el-form-item>
      </el-form>
    </template>
    <template v-else>
      <el-form inline>
        <el-form-item label="价格：">
          <el-input v-model="currentGoodsInfo.price">
            <template slot="suffix"> 元/{{ currentGoodsInfo.valuationUnit }} </template>
          </el-input>
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <el-button @click="onConfirm" type="primary">提交</el-button>
      <el-button @click="onClose">取消</el-button>
    </template>
  </el-dialog>
</template>

<script>
import NP from 'number-precision'
import limit from 'common/utils/limit'
export default {
  name: 'GoodsSkuPriceEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    goodsItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentGoodsInfo: {}
    }
  },
  methods: {
    inputHandler(row, key) {
      row[key] = limit.amount(row[key])
    },
    onClose() {
      this.$emit('update:visible', false)
    },
    onConfirm() {
      this.$emit('confirm', this.currentGoodsInfo)
      this.onClose()
    },
    getGoodsUnit(type) {
      let unit = {
        TON: '吨',
        KG: '千克',
        SHEET: '张',
        ROOT: '根',
        PIECE: '件',
        AN: '个'
      }
      return unit[type]
    }
  },
  watch: {
    goodsItem: {
      handler(val) {
        let price = 0
        if (val.minPriceItemSkuVO && val.itemExtInfoVO.subItemType === 'NORMAL') {
          price = val.minPriceItemSkuVO.price
        } else if (val.itemExtInfoVO && val.itemExtInfoVO.subItemType === 'UNCERTAIN') {
          price = val.marketPrice
        }
        const { title = '', skuList = [], id } = val
        this.$set(
          this,
          'currentGoodsInfo',
          JSON.parse(
            JSON.stringify({
              id,
              title,
              valuationUnit: this.getGoodsUnit(val.itemExtInfoVO.valuationUnitValue),
              skuList: skuList.map(item => ({
                ...item,
                price: NP.divide(item.price || 0, 100)
              })),
              price: NP.divide(price || 0, 100)
            })
          )
        )
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus" scoped></style>
